import { forwardRef, Ref } from 'react'
import { ButtonTheme, ButtonV2, ButtonV2Props } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { ColorsIcon } from './styles'

export const CustomizationButton = forwardRef(
  (props: ButtonV2Props<'button'>, ref: Ref<HTMLButtonElement>) => {
    const { i18n } = useI18n()
    return (
      <ButtonV2
        ref={ref}
        leadingIcon={<ColorsIcon />}
        theme={ButtonTheme.ghost}
        size="small"
        data-testid="customization-button"
        id="select-resume-template-button"
        {...props}
      >
        {i18n.t('builder.resume_editor.customization')}
      </ButtonV2>
    )
  },
)
